import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Container, Theme } from '@material-ui/core';

import { FCC } from '../../util';

const useStyles = makeStyles((theme: Theme) => ({
    heroContent: {
        backgroundImage:
            'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("drops.jpg")',
        padding: theme.spacing(25, 0, 25),
        marginTop: '1rem',
        color: 'white',
        paddingBottom: 'auto',
        borderBottomWidth: '1',
        borderColor: 'white',
        height: '100%'
    }
}));

export interface HeroProps {
    title: string | JSX.Element;
    description?: string | JSX.Element;
}

const HeroWImage: FCC<HeroProps> = (props) => {
    const styles = useStyles();
    return (
        <div className={styles.heroContent}>
            <Container>
                {typeof props.title === 'string' ? (
                    <Typography component="h1" variant="h2" align="center" gutterBottom>
                        {props.title}
                    </Typography>
                ) : (
                    props.title
                )}
                {typeof props.description === 'string' ? (
                    <Typography variant="h5" align="center" paragraph>
                        {props.description || ''}
                    </Typography>
                ) : (
                    props.description
                )}
                {props.children}
            </Container>
        </div>
    );
};

export default HeroWImage;
